import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Box, Button, Divider, Skeleton, Typography } from "@mui/material";

import APP_ROUTES from "../../../../routers/routeConstants";
import { formatImgUrl } from "../../../../utils/cardFormating";

import { useGetCurrentPlan } from "../../api/queries/useGetCurrentPlan";
import { UpgradePlanButtonIcon } from "../../assets/icons/plans-icons";

const CurrentPlan = () => {
  const { data, isLoading } = useGetCurrentPlan();
  const { t, i18n } = useTranslation("plans", { keyPrefix: "page.plansOverviewPage" });
  const navigate = useNavigate();
  if (isLoading) return <CurrentPlanLoadingCard />;
  if (!isLoading && !data?.data?.data) return null;

  const plan = data?.data?.data?.plan;
  const planType = plan?.subscriptionType || plan;
  const { isFree = false, imageUrl = "", title = "", description = "" } = planType || {};
  const subscribed = data?.data?.subscribed ?? false;

  const handleNavigateToPlans = () => navigate(APP_ROUTES.PLANS);
  return (
    <Box sx={styles.root}>
      <Box sx={styles.planContainer}>
        <Typography sx={styles.activePlan}>{t("active")}</Typography>
        {/* {imageUrl && <Box component="img" src={formatImgUrl(imageUrl)} alt={title} sx={styles.image} />} */}
        {/* @ts-ignore */}
        <Box dangerouslySetInnerHTML={{ __html: planType?.svgImageUrl }} sx={styles.image} />
        <Box sx={styles.planInfo}>
          <Box sx={styles.planTitleContainer}>
            <Typography variant="h6" sx={styles.planTitle}>
              {title}
            </Typography>
            {isFree && <Typography sx={styles.freePlan}>{t("free")}</Typography>}
          </Box>
          <Typography sx={styles.description}>{description}</Typography>
        </Box>
      </Box>
      <Divider flexItem orientation="horizontal" />
      <Box sx={styles.controlPlanContainer}>
        {subscribed && (
          <Button sx={styles.controlPlanButton} endIcon={<UpgradePlanButtonIcon />} onClick={handleNavigateToPlans}>
            {t("renewPlan")}
          </Button>
        )}
        {!subscribed && (
          <Button sx={styles.controlPlanButton} endIcon={<UpgradePlanButtonIcon />} onClick={handleNavigateToPlans}>
            {t("upgradePlan")}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default CurrentPlan;

const CurrentPlanLoadingCard = () => {
  return (
    <Box sx={styles.root}>
      <Box sx={styles.planContainer}>
        <Skeleton variant="text" width={60} height={24} sx={{ position: "absolute", top: "24px", right: "24px" }} />
        <Skeleton variant="rounded" width={40} height={40} />

        <Box sx={styles.planInfo}>
          <Box sx={styles.planTitleContainer}>
            <Skeleton variant="text" width={100} height={40} />
            <Skeleton variant="text" width={40} height={24} />
          </Box>
          <Box>
            <Skeleton variant="text" width="100%" height={20} />
            <Skeleton variant="text" width="80%" height={20} />
          </Box>
        </Box>
      </Box>
      <Divider flexItem orientation="horizontal" />
      <Box sx={styles.controlPlanContainer}>
        <Skeleton variant="text" width={100} height={40} />
      </Box>
    </Box>
  );
};

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "12px",
    // border: "1px solid var(--Brand-200, #98FF90)",
    // background: "var(--Brand-100, #CCF5C6)",
    border: "1px solid var(--Gray-300, #D0D5DD)",
    background: "var(--Base-White, #FFF)",
  },
  planContainer: {
    position: "relative",
    padding: "24px",
  },
  image: {
    width: "40px",
    height: "40px",
  },
  planInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  planTitleContainer: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },
  planTitle: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 750,
    lineHeight: "32px",
  },
  activePlan: {
    position: "absolute",
    top: "24px",
    right: "24px",

    color: "var(--Gray-700, #344054)",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",

    borderRadius: "6px",
    border: "1px solid var(--Gray-300, #D0D5DD)",
    background: "var(--Base-White, #FFF)",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    padding: "2px 8px 2px 22px",

    "&::before": {
      content: "''",
      position: "absolute",
      top: "50%",
      left: "8px",
      transform: "translateY(-50%)",
      width: "6px",
      height: "6px",
      background: "var(--Brand-500, #00B809)",
      borderRadius: "50%",
    },
  },
  freePlan: {
    width: "fit-content",
    height: "fit-content",
    color: "var(--Brand-700, #076D0D)",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    borderRadius: "16px",
    border: "1px solid var(--Brand-200, #98FF90)",
    background: "var(--Brand-50, #E7FFE4)",
    padding: "2px 10px",
  },
  description: {
    fontFamily: "Montserrat",
    color: "var(--Dark---1000, #111)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  controlPlanContainer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "16px 24px",
  },
  controlPlanButton: {
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    background: "linear-gradient(90deg, #2C4DED 0%, #9D00EC 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    padding: "0",
    borderRadius: "0",
  },
};
